import { createContext } from "react";

import type { NormalizedCustomerDto } from "../helpers/normalizeCustomerDto";

const CustomerContext = createContext<NormalizedCustomerDto | undefined>(undefined);

CustomerContext.displayName = "CustomerContext";

export default CustomerContext;
